import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { BenchmarkRequest } from "./benchmark";
import { ConfigResult } from "./config_result";
export const protobufPackage = "snapchat.cdp.cof";
export interface ConfigTargetingResponseDebugData {
    abResultChecksumInput: string;
}
export interface CofGradualRollout {
    uuid: Uint8Array;
    isControl: boolean;
}
export interface ConfigTargetingResponse {
    configResults: ConfigResult[];
    configResultsEtag: string;
    benchmarkRequest: BenchmarkRequest | undefined;
    fullResults: boolean;
    abResultChecksum: number;
    iso3166Alpha2CountryCodeFromRequestIp: string;
    debugData: ConfigTargetingResponseDebugData | undefined;
    cofGrapheneContext: Uint8Array;
}
function createBaseConfigTargetingResponseDebugData(): ConfigTargetingResponseDebugData {
    return { abResultChecksumInput: "" };
}
export const ConfigTargetingResponseDebugData: MessageFns<ConfigTargetingResponseDebugData> = {
    encode(message: ConfigTargetingResponseDebugData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.abResultChecksumInput !== "") {
            writer.uint32(10).string(message.abResultChecksumInput);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): ConfigTargetingResponseDebugData {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConfigTargetingResponseDebugData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.abResultChecksumInput = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<ConfigTargetingResponseDebugData>, I>>(base?: I): ConfigTargetingResponseDebugData {
        return ConfigTargetingResponseDebugData.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<ConfigTargetingResponseDebugData>, I>>(object: I): ConfigTargetingResponseDebugData {
        const message = createBaseConfigTargetingResponseDebugData();
        message.abResultChecksumInput = object.abResultChecksumInput ?? "";
        return message;
    },
};
function createBaseCofGradualRollout(): CofGradualRollout {
    return { uuid: new Uint8Array(0), isControl: false };
}
export const CofGradualRollout: MessageFns<CofGradualRollout> = {
    encode(message: CofGradualRollout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.uuid.length !== 0) {
            writer.uint32(10).bytes(message.uuid);
        }
        if (message.isControl !== false) {
            writer.uint32(16).bool(message.isControl);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): CofGradualRollout {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCofGradualRollout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.uuid = reader.bytes();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.isControl = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<CofGradualRollout>, I>>(base?: I): CofGradualRollout {
        return CofGradualRollout.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<CofGradualRollout>, I>>(object: I): CofGradualRollout {
        const message = createBaseCofGradualRollout();
        message.uuid = object.uuid ?? new Uint8Array(0);
        message.isControl = object.isControl ?? false;
        return message;
    },
};
function createBaseConfigTargetingResponse(): ConfigTargetingResponse {
    return {
        configResults: [],
        configResultsEtag: "",
        benchmarkRequest: undefined,
        fullResults: false,
        abResultChecksum: 0,
        iso3166Alpha2CountryCodeFromRequestIp: "",
        debugData: undefined,
        cofGrapheneContext: new Uint8Array(0),
    };
}
export const ConfigTargetingResponse: MessageFns<ConfigTargetingResponse> = {
    encode(message: ConfigTargetingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.configResults) {
            ConfigResult.encode(v!, writer.uint32(10).fork()).join();
        }
        if (message.configResultsEtag !== "") {
            writer.uint32(18).string(message.configResultsEtag);
        }
        if (message.benchmarkRequest !== undefined) {
            BenchmarkRequest.encode(message.benchmarkRequest, writer.uint32(26).fork()).join();
        }
        if (message.fullResults !== false) {
            writer.uint32(32).bool(message.fullResults);
        }
        if (message.abResultChecksum !== 0) {
            writer.uint32(40).int32(message.abResultChecksum);
        }
        if (message.iso3166Alpha2CountryCodeFromRequestIp !== "") {
            writer.uint32(50).string(message.iso3166Alpha2CountryCodeFromRequestIp);
        }
        if (message.debugData !== undefined) {
            ConfigTargetingResponseDebugData.encode(message.debugData, writer.uint32(58).fork()).join();
        }
        if (message.cofGrapheneContext.length !== 0) {
            writer.uint32(106).bytes(message.cofGrapheneContext);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): ConfigTargetingResponse {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConfigTargetingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.configResults.push(ConfigResult.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.configResultsEtag = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.benchmarkRequest = BenchmarkRequest.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.fullResults = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.abResultChecksum = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.iso3166Alpha2CountryCodeFromRequestIp = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.debugData = ConfigTargetingResponseDebugData.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.cofGrapheneContext = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<ConfigTargetingResponse>, I>>(base?: I): ConfigTargetingResponse {
        return ConfigTargetingResponse.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<ConfigTargetingResponse>, I>>(object: I): ConfigTargetingResponse {
        const message = createBaseConfigTargetingResponse();
        message.configResults = object.configResults?.map((e) => ConfigResult.fromPartial(e)) || [];
        message.configResultsEtag = object.configResultsEtag ?? "";
        message.benchmarkRequest = (object.benchmarkRequest !== undefined && object.benchmarkRequest !== null)
            ? BenchmarkRequest.fromPartial(object.benchmarkRequest)
            : undefined;
        message.fullResults = object.fullResults ?? false;
        message.abResultChecksum = object.abResultChecksum ?? 0;
        message.iso3166Alpha2CountryCodeFromRequestIp = object.iso3166Alpha2CountryCodeFromRequestIp ?? "";
        message.debugData = (object.debugData !== undefined && object.debugData !== null)
            ? ConfigTargetingResponseDebugData.fromPartial(object.debugData)
            : undefined;
        message.cofGrapheneContext = object.cofGrapheneContext ?? new Uint8Array(0);
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
